import React, { useContext, useEffect, useState } from 'react'
import { Trans } from 'react-i18next'
import { readableCount } from 'app/modules/reports/helpers'
import { AuthContext } from 'app/modules/user'
import { statService } from 'app/modules/reports/services'
import { logger } from '../logger'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { applicationConfiguration } from 'app/modules/shared'

export function HomeTitle({ isCommunity, isFancyTheme }: { isCommunity: boolean; isFancyTheme: boolean }) {
  const { _t } = useTypedTranslation()
  const config = useContext(applicationConfiguration)
  const [iocStat, setIocStat] = useState<number | null>(null)
  const auth = useContext(AuthContext)
  const user = auth.user
  const isAdmin = user?.isAdmin

  useEffect(() => {
    //Fetch IOC stats
    const fetch = async () => {
      try {
        const result = await statService.getIoc()
        setIocStat(parseInt(result.count ?? 0))
      } catch (e: any) {
        if (e.message.startsWith('401')) {
          logger.error(_t('stat-not-authorized'))
        } else {
          logger.error(e.message)
        }
      }
    }

    fetch()
  }, [])

  const getSubtitle = () => {
    if (config.isReputationEnabled) {
      return (
        <Trans i18nKey="homepage-subtitle-with-reputation-enabled" context={readableCount(iocStat ?? 0)}>
          The local threat graph has <span className="text-normal">{readableCount(iocStat ?? 0)} IOCs</span> and MD
          Cloud Reputation is adding <span className="text-normal">40B+ Hashes, IPs, Domains</span> for maximum
          protection.
        </Trans>
      )
    }

    if (isAdmin) {
      return (
        <Trans i18nKey="homepage-subtitle-with-reputation-disabled" context={readableCount(iocStat ?? 0)}>
          The local threat graph has <span className="text-normal">{readableCount(iocStat ?? 0)} IOCs</span>. Please
          enable
          <a
            className="theme-link"
            href="https://docs.opswat.com/filescan/integrations/reputation-api-integration"
            target="_blank"
          >
            MD Cloud Reputation <i className="ds3-icon ds3-information" />
          </a>
          to add another 40B+ Hashes, IPs, Domains for maximum protection.
        </Trans>
      )
    }

    return (
      <Trans i18nKey="homepage-subtitle" context={readableCount(iocStat ?? 0)}>
        The local threat graph has <span className="text-normal">{readableCount(iocStat ?? 0)} IOCs</span>.
      </Trans>
    )
  }

  return (
    <div className={isFancyTheme ? 'home-title-themed' : undefined}>
      <h1 className="home-title h3">
        {isCommunity ? <div>{_t('welcome-title')}</div> : null}

        <Trans i18nKey="homepage-title" context={readableCount(iocStat ?? 0)}>
          Uncover <span className="text-normal">Hidden Threats</span>: Insightful Malware Analysis Powered by Emulation.
        </Trans>
      </h1>

      <div className="home-subtitle">{getSubtitle()}</div>
    </div>
  )
}
